// adattato da https://github.com/Azure-Samples/AzureSpeechReactSample

import * as speechsdk from 'microsoft-cognitiveservices-speech-sdk'
import axios from 'axios'
import Cookie from 'universal-cookie'
import { AppConfig } from "../configDef";

// Demo key
// const azureSpeechKey = "41g5ex1gnT738CZ3kHWMOCnFHjXGzBnjUzkvrhOqQKAPzBBqXboAJQQJ99BGAC5RqLJXJ3w3AAAYACOGM4GF"
// const azureSpeechKey = "9Oqnhr3rPjomD6ia6VXJ6bA587AJ7YzMf1ksYEAT3V01CGjfErzvJQQJ99BCAC5RqLJXJ3w3AAAYACOGTU0l"
// const azureSpeechRegion = "westeurope"
// const azureSpeechKey = "444eb1042cf7422c8d66f169b2ff12bc"

const retrieveToken = async () => {
    const key = AppConfig.AZURE_SPEECH_KEY
    const region = AppConfig.AZURE_SPEECH_REGION

    const headers = {
        headers: {
            'Ocp-Apim-Subscription-Key': key,
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    }
    try {
        const tokenResponse = await axios.post(`https://${region}.api.cognitive.microsoft.com/sts/v1.0/issueToken`, null, headers)
        // console.log(tokenResponse)
        return {token: tokenResponse.data, region: region}
    } catch (err) {
        console.error(err)
        return null
    }
}

const tokenName = 'azure-speech-token'
let lastFetchTokenDate: null | Date = null
const getTokenOrRefresh = async () => {
    const cookie = new Cookie();
    const speechToken = cookie.get(tokenName);
    // tempo per richiedere il cookie, sperando che aiuti con il web socket error
    const maxTimeElapsed = lastFetchTokenDate === null || (new Date().getTime()) -  lastFetchTokenDate.getTime() > 120000

    if (maxTimeElapsed || speechToken === undefined) {
        const res = await retrieveToken()
        if (res === null) {
            return null
        }
        const token = res.token
        const region = res.region
        cookie.set(tokenName, region + ':' + token, {maxAge: 540, path: '/'})
        lastFetchTokenDate = new Date()

        // console.log('Token fetched from Azure: ' + token)
        return { authToken: token, region: region }
    } else {
        // console.log('Token fetched from cookie: ' + speechToken)
        const idx = speechToken.indexOf(':')
        return { authToken: speechToken.slice(idx + 1), region: speechToken.slice(0, idx) }
    }
}
const clearToken = () => {
    const cookie = new Cookie()
    cookie.remove(tokenName)
}

export type RecognitionEvent = {
    type: 'starting',
} | {
    type: 'started',
} | {
    type: 'ended',
    result: string | null,
} | {
    type: 'error',
    error: 'permission_denied' | 'unknown',
}

export const pushToTalkMode = false
let recognizer: speechsdk.SpeechRecognizer | null = null
let recognitionActive = false
let alreadySentResultAfterStop = false
export const sttFromMic = async (azureLanguage: string, callback: (event: RecognitionEvent) => void): Promise<boolean> => {
    const recognizerErrorHandler = (error: string) => {
        console.error("error in sttFromMic:")
        console.error(error)
        if (pushToTalkMode) {
            stopStt()
        }
        // console.log("clearing token after azure speech recognition error")
        clearToken()
        callback({type: 'ended', result: null})
    }

    // Pre-flight microphone permission check. Edge (and some other browsers) surface
    // the OS-level "Permission denied by system" error here rather than inside the SDK.
    try {
        const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
        stream.getTracks().forEach(t => t.stop())
    } catch (permErr: any) {
        const isPermissionDenied = permErr && (permErr.name === 'NotAllowedError' || permErr.name === 'PermissionDeniedError')
        console.error('Microphone permission error:', permErr)
        if (isPermissionDenied) {
            callback({ type: 'error', error: 'permission_denied' })
        } else {
            callback({ type: 'error', error: 'unknown' })
        }
        return false
    }

    try {
        const tokenObj = await getTokenOrRefresh()
        if (tokenObj) {
            const speechConfig = speechsdk.SpeechConfig.fromAuthorizationToken(tokenObj.authToken, tokenObj.region)
            speechConfig.speechRecognitionLanguage = azureLanguage
            
            if (true/*!recognizer*/) { // reinizializza sempre tutto, per vedere se evita errore socket
                const audioConfig = speechsdk.AudioConfig.fromDefaultMicrophoneInput()
                recognizer = new speechsdk.SpeechRecognizer(speechConfig, audioConfig)
                // Create and apply phrase list
                const phraseList = speechsdk.PhraseListGrammar.fromRecognizer(recognizer);
                phraseList.addPhrase("Dahua");
                const conn = speechsdk.Connection.fromRecognizer(recognizer)
                conn.setMessageProperty("speech.context", "phraseDetection", {
                    "INTERACTIVE": {
                        "segmentation": {
                            "mode": "custom",
                            "segmentationSilenceTimeoutMs": 2000
                        }
                    },
                    mode: "Interactive"
                })
            }

            recognizer.sessionStarted = () => {
                if (!pushToTalkMode || recognitionActive) {
                    callback({type: 'started'})
                }
            }

            callback({type: 'starting'})

            if (!pushToTalkMode) {
                recognizer.recognizeOnceAsync(result => {
                    if (result.reason === speechsdk.ResultReason.RecognizedSpeech) {
                        callback({type: 'ended', result: result.text})
                        // console.log("sent result: " + result.text)
                    } else {
                        callback({type: 'ended', result: null})
                        // console.log("no result")
                    }
                }, err => {
                    console.error(err)
                    callback({type: 'ended', result: null})
                })
            } else {
                recognitionActive = true

                recognizer.recognized = (sender, event) => {
                    if (!recognitionActive && !alreadySentResultAfterStop) {
                        if (event && event.result && typeof event.result.text === 'string') {
                            alreadySentResultAfterStop = true
                            callback({type: 'ended', result: event.result.text})
                            // console.log("sent result: " + event.result.text)
                        } else {
                            callback({type: 'ended', result: null})
                            console.log("no result")
                        }
                    }
                }

                recognizer.startContinuousRecognitionAsync(undefined, recognizerErrorHandler)
            }

            return true
        } else {
            callback({type: 'ended', result: null})
            return false
        }
    } catch (e) {
        console.error("exception in sttFromMic")
        recognizerErrorHandler(JSON.stringify(e))
        return false
    }
}

export const stopStt = () => {
    if (recognizer) {
        recognizer.stopContinuousRecognitionAsync()
        alreadySentResultAfterStop = false
    }
    recognitionActive = false
}

export let ttsPlayer: speechsdk.SpeakerAudioDestination | null = null;
let muteAudio = false
let playAudioTimeout: undefined | ReturnType<typeof setTimeout> = undefined;
export const tts = async (
    text: string, azureLanguage: string, azureVoice: string,
    audioStartCallback: (audioPlayer: speechsdk.SpeakerAudioDestination) => void,
    audioEndCallback: (audioPlayer: speechsdk.SpeakerAudioDestination) => void,
    visemeReceivedCallback: (sender: speechsdk.SpeechSynthesizer, event: speechsdk.SpeechSynthesisVisemeEventArgs) => void,
): Promise<boolean> => {
    const tokenObj = await getTokenOrRefresh()
    console.log('[TTS] Token object:', tokenObj, 'lastFetchTokenDate:', lastFetchTokenDate);

    if (tokenObj) {
        if (lastFetchTokenDate && (new Date().getTime() - lastFetchTokenDate.getTime() < 2000)) {
            console.log('[TTS] Short delay after token fetch');
            await new Promise(res => setTimeout(res, 200));
        }
        if (ttsPlayer !== null) {
            console.log('[TTS] Closing previous ttsPlayer');
            ttsPlayer.pause()
            ttsPlayer.close()
        }
        const newTtsPlayer = new speechsdk.SpeakerAudioDestination()
        console.log('[TTS] Creating newTtsPlayer:', newTtsPlayer);

        newTtsPlayer.onAudioStart = () => {
            console.log('[TTS] Audio started');
            audioStartCallback(newTtsPlayer)
        }
        newTtsPlayer.onAudioEnd = () => {
            console.log('[TTS] Audio ended');
            audioEndCallback(newTtsPlayer)
        }
        console.log('[TTS] onAudioEnd set:', !!newTtsPlayer.onAudioEnd);
        ttsPlayer = newTtsPlayer

        setTimeout(() => {
            updateTtsPlayerMute(muteAudio)
        }, 100)

        console.log('[TTS] Creating SpeechConfig with token:', tokenObj.authToken, 'region:', tokenObj.region);
        const speechConfig = speechsdk.SpeechConfig.fromAuthorizationToken(tokenObj.authToken, tokenObj.region)
        speechConfig.speechSynthesisLanguage = azureLanguage
        speechConfig.speechSynthesisVoiceName = azureVoice

        const audioConfig = speechsdk.AudioConfig.fromSpeakerOutput(ttsPlayer)

        console.log('[TTS] Creating SpeechSynthesizer');
        const synth = new speechsdk.SpeechSynthesizer(speechConfig, audioConfig)
        synth.visemeReceived = (sender, event) => {
            // console.log('[TTS] Viseme received:', event);
            visemeReceivedCallback(sender, event)
        }

        console.log('[TTS] Calling speakTextAsync');
        // Before calling speakTextAsync
        await Promise.resolve(); // microtask delay
        synth.speakTextAsync(
            text,
            result => {
                console.log('[TTS] speakTextAsync success:', result);
                if (result) {
                    const durationMs = result.audioDuration / 10000
                    console.log("audio duration: " + durationMs + " ms")
                }
                synth.close()
            },
            error => {
                console.error('[TTS] speakTextAsync error:', error)
                synth.close()
            }
        )
        return true;
    } else {
        console.error('[TTS] No token object');
        return false;
    }
}

export const stopTtsPlay = () => {
    if (ttsPlayer) {
        ttsPlayer.pause()
        ttsPlayer.close()
        ttsPlayer = null
    }
}

const updateTtsPlayerMute = (newMute: boolean) => {
    if (ttsPlayer !== null) {
        if (newMute) {
            ttsPlayer.mute()
        } else {
            ttsPlayer.unmute()
        }
    }
}
export const setTtsMuteAudio = (newMute: boolean) => {
    muteAudio = newMute
    updateTtsPlayerMute(newMute)
}